webpackJsonp([40,47],{

/***/ 1273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  mounted: function mounted() {}
};

/***/ }),

/***/ 1421:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".body-bgx[data-v-bbdbdc2e]{height:100%;width:100%}img[data-v-bbdbdc2e]{-webkit-filter:opacity(60%);filter:opacity(60%)}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/NotFoundView.vue"],"names":[],"mappings":"AACA,2BAEE,YAAY,AACZ,UAAW,CACZ,AACD,qBACI,4BAA6B,AAC/B,mBAAqB,CACtB","file":"NotFoundView.vue","sourcesContent":["\n.body-bgx[data-v-bbdbdc2e]{\n  /*position:absolute;*/\n  height:100%;\n  width:100%;\n}\nimg[data-v-bbdbdc2e] {\n    -webkit-filter: opacity(60%); /* Safari 6.0 - 9.0 */\n  filter: opacity(60%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1510:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1421);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("0ad2afac", content, true, {});

/***/ }),

/***/ 1722:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "body-bgx  pb-5 mt-5 pt-5"
  }, [_c('v-flex', {
    staticStyle: {
      "margin": "0 auto",
      "text-align": "center"
    },
    attrs: {
      "md3": ""
    }
  }, [_c('img', {
    staticStyle: {
      "width": "60%",
      "color": "#000"
    },
    attrs: {
      "src": "/static/images/emoticon-down.png"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("404")]), _vm._v(" "), _c('h5', [_vm._v("Page not found")]), _vm._v(" "), _c('p', [_vm._v("The Page you are looking for does not exists or an error occured.\n                "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Head over to the home page")])])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1510)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1273),
  /* template */
  __webpack_require__(1722),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bbdbdc2e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/40.5b1bfbcb944757b5479c.js